import { FC } from 'react';
import clsx from 'clsx';
import { IDropdownItem } from '../../types';
import styles from './styles.module.css';

const DropdownItem: FC<IDropdownItem> = (props) => {

  const {
    className = '',
    isHighlighted = false,
    children,
    ...rest
  } = props;

  const hlClass = isHighlighted ? styles.isHighlighted : '';

  return (
    <div className={clsx('dropdown-item', styles.item, hlClass, className)} {...rest}>
      {children}
    </div>
  );

};

export default DropdownItem;
